export default {
  universe: null,
};
